module.exports = __webpack_public_path__ + "img/setup-4.5efd97dc.png";